import { useEffect, useRef } from "react";
import { Modal } from "bootstrap";
import "../components/CustomModal.css";
import "bootstrap/dist/css/bootstrap.min.css";

function CustomModal({ show, onClose, content }) {
  const modalRef = useRef(null);
  const modalInstanceRef = useRef(null);

  useEffect(() => {
    if (modalRef.current) {
      const modalElement = modalRef.current;
      const handleHidden = () => onClose();

      // Ensure we initialize the modal only once
      modalInstanceRef.current = Modal.getOrCreateInstance(modalElement);

      if (show) {
        modalInstanceRef.current.show();
        modalElement.addEventListener("hidden.bs.modal", handleHidden);
      }

      return () => {
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
      };
    }
  }, [show, onClose]);

  const renderContent = () => {
    if (!content) return null;

    // Multiple images
    if (Array.isArray(content)) {
      return (
        <div
          id="carouselExample"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {content.map((imgSrc, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <img
                  src={imgSrc}
                  className="d-block w-100"
                  alt={`Poster ${index + 1}`}
                />
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" />
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" />
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      );
    }

    // Single image
    return <img src={content} className="d-block w-100" alt="Poster" />;
  };

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Poster</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
}

export default CustomModal;